import { render, staticRenderFns } from "./SettingsActor.vue?vue&type=template&id=7b12251c&scoped=true&"
import script from "./SettingsActor.vue?vue&type=script&lang=js&"
export * from "./SettingsActor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12251c",
  null
  
)

export default component.exports